import React from 'react';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import { paramOptions } from '../../constants';
import PageFilter from '../../component/PageFilter';
import Breadcrumb from '../../component/Breadcrumb';
import { SwitchStyle } from '../../component/SwitchStyle';
import { fetchSheetSettingsData, updateSheetSettings } from '../../api/mappingApi';
import { Grid, Typography, Box, ListItem, FormControlLabel, Button } from '@mui/material';
import Loader from '../../component/Loader/Loader';

const Settings = () => {

  const [sheetFilter, setSheetFilter]   = React.useState('');
  const [settingsData, setSettingsData] = React.useState([]);
  const [showLoader, setShowLoader]     = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);
      const data = await fetchSheetSettingsData(sheetFilter);
      setShowLoader(false); 
      setSettingsData(data);
    }
    if(sheetFilter !== ''){
      fetchData();
    }
  },[sheetFilter])

  // const fetchData = async () => {
  //   setShowLoader(true);
  //   const data = await fetchSheetSettingsData(sheetFilter);
  //   setShowLoader(false);
  //   setSettingsData(data);
  // }

  const handleSheetFilter = (e) => {
    setSheetFilter(e.target.value)
  }
  

  const handleSwitchChange = (e) => {
    let id      = e.target.value;
    let checked = e.target.checked;
    const updatedData = settingsData.map(setting => {
        if(setting.id.toString() === id){
          return {...setting,is_enabled: checked ? 1 : 0}
        }
        return setting;
    });
    setSettingsData(updatedData);
  };

  const handleSaveData = async () => {
    const selectedSheet        = sheetFilter;
    const updatedSettingsData  = settingsData;
    setShowLoader(true);
    const result = await updateSheetSettings(selectedSheet,updatedSettingsData);
    setShowLoader(false);
    swal({
      title: "Success",
      text: result.message,
      icon: "success",
    });
  } 

  return (
    <>
      {showLoader && 
        <Loader />
      }
      <Breadcrumb title="Settings">
        <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
          Dashboard
        </Typography>
        <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
         Settings
        </Typography>
      </Breadcrumb>
      <Box component="section">
        <Grid className="contentBox">
          <Grid container spacing={1}>
            <Grid item md={6} sm={12} xs={12}>
              <PageFilter 
                options={paramOptions}
              // width={30}
                filterValue={sheetFilter}
                handleSheetFilter={handleSheetFilter} 
              />
            </Grid>
            { settingsData.length > 0 && 
                <>
                  <Grid item xs={8} md={9}>
                    <ListItem className='headingItem'>Column Name</ListItem>
                  </Grid>
                  <Grid item xs={4} md={3}>
                    <ListItem className='headingItem actionItem'>Action</ListItem>
                  </Grid>
                </>
            }
            {settingsData?.map((setting,index) => {
              return (
                <>
                  <Grid item xs={8} md={9}>
                    <ListItem key={index} className='columnList'>{setting.column_name}</ListItem>
                  </Grid>
                  <Grid item xs={4} md={3}>  
                    <ListItem key={index} className='actionButtonList'>
                      <FormControlLabel value={index}  
                        control={ 
                          <SwitchStyle 
                            key = {index}
                            checked={setting.is_enabled ? true : false}
                            value={setting.id}
                            onChange={handleSwitchChange}
                          />
                        } 
                      />
                    </ListItem>
                  </Grid>
                </>
              )
            })}
            { settingsData.length > 0 &&
              <Grid item xs={12} > 
                <Button 
                  variant="contained"
                  color="primary" 
                  onClick={handleSaveData}
                  size="small"
                > 
                  Update 
                </Button>
              </Grid>
            }
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Settings;
